import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import moment from 'moment';
import { lastValueFrom } from 'rxjs';
import { WsUserProfileService } from 'src/app/ws/wsUserProfile/ws-user-profile.service';

@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent {
  @Input() orderId: any;
  @Output() saveClick = new EventEmitter();
  orderDetail: any;
  id: any;
  deleteType: any;
  totalAmount: any = 0;
  totalProductPrice: any = 0;
  subTotalInclusiveTax: any = 0;
  totalSavings: any = 0;
  discountSelected: any = [];
  showDiscountOnTotal: boolean = false;
  discountCode: any;
  discountId: any;
  productIds: any;
  discountApplied: any = 0;
  brandIds: any;
  categoryIds: any;
  discountAmount: any;
  constructor(private wsUserProfileService: WsUserProfileService, private router: Router){
  
  }

  ngOnChanges(){
    if(this.orderId){
      this.getOrderDetail(this.orderId)
    }
  }

  async getOrderDetail(orderId: any) {
    const orderList = this.wsUserProfileService.getOrderDetail(orderId)
    await lastValueFrom(orderList).then(async response => {
      if (response && response.statusCode == 200) {
        this.orderDetail = response.data[0];       
        this.discountSelected = this.orderDetail.discounts.length > 0 ? this.orderDetail.discounts[0] : []
        this.calculateAmountWithTax();
        this.calculateIndividual();
      }
    })
  }

  async calculateIndividual(){
    if (this.discountSelected.on_cart_value || this.discountSelected.apply_discount_on_cart_value) {
      this.showDiscountOnTotal = true;
      this.discountCode = this.discountSelected.discount_code;
      this.discountId = this.discountSelected.id;
    } else {
      this.showDiscountOnTotal = false;
      if (this.discountSelected.is_all) {
        if (this.discountSelected.type == 'product') {
          this.discountCode = this.discountSelected.discount_code;
          await this.orderDetail.product_detail.forEach((product: any, i: any) => {
            this.discountCalculate((product.your_price * product['product_qty']), i)
          })
        } else if (this.discountSelected.type == 'brand') {
          this.discountCode = this.discountSelected.discount_code;
          await this.orderDetail.product_detail.forEach((product: any, i: any) => {
            this.discountCalculate((product.your_price * product['product_qty']), i)
          })
        } else if (this.discountSelected.type == 'category') {
          this.discountCode = this.discountSelected.discount_code;
          await this.orderDetail.product_detail.forEach((product: any, i: any) => {
            this.discountCalculate((product.your_price * product['product_qty']), i)
          })
        }
        this.discountId = this.discountSelected.id;
      } else {
        if (this.discountSelected.type == 'product') {
          this.discountCode = this.discountSelected.discountCode;
          await this.productIds.forEach((id: any, i: any) => {
            if (this.discountSelected.product_id_Array.includes(id)) {
              this.discountCalculate((this.orderDetail.product_detail[i].your_price * this.orderDetail.product_detail[i]['product_qty']), i)
            }
          })
        } else if (this.discountSelected.type == 'brand') {
          this.discountCode = this.discountSelected.discount_code;
          await this.brandIds.forEach((id: any, i: any) => {
            if (this.discountSelected.brand_id_Array.includes(id)) {
              this.discountCalculate((this.orderDetail.product_detail[i]['productdetail'].your_price * this.orderDetail.product_detail[i]['product_qty']), i)
            }
          })
        } else if (this.discountSelected.type == 'category') {
          this.discountCode = this.discountSelected.discount_code;
          await this.categoryIds.forEach((id: any, i: any) => {
            if (this.discountSelected.category_id_Array.includes(id)) {
              this.discountCalculate((this.orderDetail.product_detail[i]['productdetail'].your_price * this.orderDetail.product_detail[i]['product_qty']), i)
            }
          })
        }
       
        this.discountId = this.discountSelected.id;
      }
    }
  }

  discountCalculate(your_price: any, i: any) {
    if (this.discountSelected.amount < 1) {
      this.discountApplied = your_price * this.discountSelected.percentage / 100;
      if (this.discountApplied > your_price) {
        this.discountApplied = your_price;
      }
      if (this.discountApplied > this.discountSelected.max_amount && this.discountSelected.max_amount > 0) {
        if (this.discountSelected.max_amount > your_price) {
          this.discountApplied = your_price;
        } else {
          this.discountApplied = this.discountSelected.max_amount;
        }
      }
     this.orderDetail.product_detail[i]['discountApplied'] = this.discountApplied;
     this.orderDetail.product_detail[i]['discountAppliedAmount'] = your_price - this.discountApplied;
     this.orderDetail.product_detail[i]['discountType'] = 'percentage';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }
    if (this.discountSelected.amount > 0) {
      if (your_price > this.discountSelected.amount) {
        this.discountApplied = this.discountSelected.amount;
      } else {
        this.discountApplied = your_price
      }
      this.orderDetail.product_detail[i]['discountApplied'] = this.discountApplied;
      this.orderDetail.product_detail[i]['discountAppliedAmount'] = your_price - this.discountApplied;
      this.orderDetail.product_detail[i]['discountType'] = 'fix';
      this.discountAmount = this.discountAmount + this.discountApplied;
      return this.discountApplied;
    }

    this.discountApplied = 0
    this.orderDetail.product_detail[i]['discountApplied'] = this.discountApplied;
    this.orderDetail.product_detail[i]['discountAppliedAmount'] = your_price - this.discountApplied;
    this.discountAmount = this.discountAmount + this.discountApplied;

    return this.discountApplied;
  }

  calculateIndividualTotal(qty: any, price: any) {
    return qty *  price;
  }

  backToOrderList(){
    this.router.navigate(['user-my-orders'])
  }

  clickOrder(){
  }

  async calculateAmountWithTax(){
    this.totalAmount = 0;
    this.totalProductPrice = 0;
    this.subTotalInclusiveTax = 0;
   await this.orderDetail.product_detail.forEach((product:any) => {
      this.totalProductPrice = this.totalProductPrice + ((product.your_price * product.product_qty))
    })
    this.subTotalInclusiveTax = this.totalProductPrice + 0;
    this.totalAmount = this.totalProductPrice + 0 + this.orderDetail.shipping_charge - this.orderDetail.total_discount_amount;
    this.totalSavings = this.orderDetail.total_discount_amount;
  }

  showDate(val: any) {
    return moment(val).format('MMM , DD YYYY');
  }

  cancelOrder(order: any) {
    this.id = order.id;
    this.deleteType = "order"
  }

  redirectToNeedHelp(){
    const data = {data: true};
    this.router.navigate(['need-help'], {state: data})
  }

  downloadPdf() {
    this.saveClick.emit(this.orderDetail)
  }
}
